import { render, staticRenderFns } from "./MedicineAnalyzer.vue?vue&type=template&id=2fc7f84e&scoped=true&"
import script from "./MedicineAnalyzer.vue?vue&type=script&lang=js&"
export * from "./MedicineAnalyzer.vue?vue&type=script&lang=js&"
import style0 from "./MedicineAnalyzer.vue?vue&type=style&index=0&id=2fc7f84e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc7f84e",
  null
  
)

export default component.exports